module.exports = __webpack_public_path__ + "static/purpose-med-logo-49fba5d57f3bb364ac703570018f62a3.png";